import { render, staticRenderFns } from "./ActivityDetailsFromRelatedTo.vue?vue&type=template&id=1dbbd8e9&"
import script from "./ActivityDetailsFromRelatedTo.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailsFromRelatedTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports